import React, { useState, useEffect } from "react";
import { ReactComponent as SearchIcon } from '../../assets/Search.svg';
import { useTranslation } from 'react-i18next';
import i18n from '../../locales/i18n';

interface SearchProps { 
    search: string,
    setSearch: (search: string) => void;
    onSearch: () => void;
}

const Search: React.FC<SearchProps> = ({search, setSearch, onSearch}) => { 
    const { t } = useTranslation();
    const [isRTL, setIsRTL] = useState<boolean>(i18n.language === 'ar');

    // Add useEffect to handle language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            setIsRTL(i18n.language === 'ar');
        };
        
        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    return ( 
        <div className={`flex items-center ${isRTL ? 'flex-row' : 'flex-row-reverse'}`}>
            <div className={`h-14 w-auto flex items-center justify-center px-6 ${isRTL ? 'rounded-s-2xl border-s' : 'rounded-e-2xl border-r'} border-t border-b border-[#D8DADC]`}>
                <SearchIcon onClick={onSearch} className="cursor-pointer" />
            </div>
            <div className={`h-14 w-auto flex items-center justify-center px-6 ${isRTL ? 'rounded-e-2xl border-e' : 'rounded-s-2xl border-l'} border-t border-b border-[#D8DADC] w-full`}>
                <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onSearch();
                        }
                    }}
                    placeholder={t('Search for your next read!')}
                    className="w-full py-2 placeholder-[#AAAAAA] focus:outline-none text-primary_500 focus:caret-primary_blue transition-colors duration-300 placeholder-gray-400"
                    dir={isRTL ? 'rtl' : 'ltr'}
                    style={{ textAlign: isRTL ? 'right' : 'left' }}
                />
            </div>
        </div>
    )
}

export default Search;